import { LeafletPixiContext } from "./useLeafletPixi";
import { useEffect } from "react";
import { RendererName } from "@api/pixijs/renderers/OperationRenderer";
import { GeoZoneRenderer } from "@api/pixijs/renderers/GeoZoneRenderer";
import { useTypedSelector } from "@hooks/useTypedSelector";
import { useGeoZoneSliceActions } from "@hooks/useActions";
import logger from "@utils/logger";

const log = logger.getLogger("useGeoZoneRender")
export default function (pixiContext: LeafletPixiContext | undefined) {
    const {
        ids: adapterIds,
        geoZoneChangedIds,
        geoZonesByType
    } = useTypedSelector(data => data.geoZones)

    const { toggles } = useTypedSelector(data => data.geoZoneTabSettings)
    const { commit } = useGeoZoneSliceActions()

    useEffect(() => {
        if (pixiContext) {
            const pixiOverlay = pixiContext.service
            const renderer = pixiOverlay.getRendererByName<GeoZoneRenderer>(RendererName.GeoZone)
            renderer.redraw(geoZonesByType.cadastre, { cadastre: { fill: toggles.cadastre } })
            pixiOverlay.refreshPixiContainer()
        }
    }, [pixiContext, toggles.cadastre])

    useEffect(() => {
        if (pixiContext && geoZoneChangedIds.length > 0) {
            const pixiOverlay = pixiContext.service
            const renderer = pixiOverlay.getRendererByName<GeoZoneRenderer>(RendererName.GeoZone)
            renderer.redraw(geoZoneChangedIds, { cadastre: { fill: toggles.cadastre } })
            pixiOverlay.refreshPixiContainer()
            commit({ changes: geoZoneChangedIds })
        }
    }, [pixiContext, geoZoneChangedIds])

    useEffect(() => {
        if (pixiContext) {
            const renderer = pixiContext.service.getRendererByName<GeoZoneRenderer>(RendererName.GeoZone)
            const pixiOverlay = pixiContext.service
            renderer.enable()
            renderer.render(adapterIds, { cadastre: { fill: toggles.cadastre } })
            pixiOverlay.refreshPixiContainer()
        }
    }, [pixiContext, adapterIds])
}